/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Export_Usage_Dates_Hint_MonthInputs */



/**
* | output |
* | --- |
* | "Billing months whose last day falls between these two days, plus each customer's month still open. Each customer's own billing day." |
*
* @param {Admin_Export_Usage_Dates_Hint_MonthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_usage_dates_hint_month = /** @type {((inputs?: Admin_Export_Usage_Dates_Hint_MonthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Usage_Dates_Hint_MonthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abrechnungsmonate, deren letzter Tag zwischen diesen beiden Tagen liegt, plus der noch offene Monat jedes Kunden. Jeweils mit dem eigenen Abrechnungstag des Kunden.")
	return /** @type {LocalizedString} */ ("Billing months whose last day falls between these two days, plus each customer's month still open. Each customer's own billing day.")
});